export default __webpack_public_path__ + "static/media/portfolio-212.3afc9b2b.jpg";